import { FC, Fragment, useEffect, useState } from 'react'
import cn from './index.module.css'
import FolderItem from './components/FolderItem/FolderItem'
import { fetchCatalogFolders, fetchSubFolders } from './api'
import classNames from 'classnames'
import { Spin } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'

interface IFolderList {
  folders: IFolder[]
  subFolders: ISubFolder[]
  selectedFolder?: number
  selectedSubFolder?: number
  className?: string
  isLoading?: boolean
  onSelect: (value: { folder?: number; subFolder?: number }) => void
}

const FolderList: FC<IFolderList> = ({
  folders,
  subFolders,
  isLoading,
  selectedFolder,
  selectedSubFolder,
  className,
  onSelect,
}) => {
  const onFolder = (folder: IFolder) => {
    if (folder.id !== selectedFolder || selectedSubFolder)
      onSelect({ folder: folder.id })
  }

  const onSubFolder = (folder: ISubFolder) => {
    if (folder.id !== selectedSubFolder)
      onSelect({ folder: folder.parent_id, subFolder: folder.id })
  }

  return (
    <div className={classNames(cn.wrapper, className)}>
      <div className={cn.header}>Фильтры</div>
      <div className={cn.folderList}>
        {isLoading && (
          <Spin
            indicator={
              <LoadingOutlined
                spin
                onPointerEnterCapture={undefined}
                onPointerLeaveCapture={undefined}
              />
            }
          />
        )}
        {folders?.map((folder) => {
          const subList = subFolders?.filter(
            (item) => item.parent_id === folder.id,
          )

          return (
            <Fragment key={folder.id}>
              <div>
                <FolderItem
                  label={folder.name}
                  value={selectedFolder === folder.id && !selectedSubFolder}
                  onChange={() => onFolder(folder)}
                />
              </div>
              {subList?.map((subFolder) => {
                return (
                  <div
                    className={cn.subFolderWrapper}
                    key={'sub' + subFolder.id}
                  >
                    <FolderItem
                      label={subFolder.name}
                      value={selectedSubFolder === subFolder.id}
                      onChange={() => onSubFolder(subFolder)}
                    />
                  </div>
                )
              })}
            </Fragment>
          )
        })}
      </div>
    </div>
  )
}

export default FolderList
